// frontend/src/components/ScientificAnalysis/DatasetSelector.tsx

import React from 'react';

interface Props {
  datasets: any[];
  selectedDataset: any | null;
  onSelect: (dataset: any) => void;
  loading: boolean;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const DatasetSelector: React.FC<Props> = ({
  datasets,
  selectedDataset,
  onSelect,
  loading,
}) => {
  if (loading && datasets.length === 0) {
    return (
      <div style={{ marginBottom: '24px' }}>
        <div style={{ color: '#8899aa', padding: '20px' }}>
          Carregando datasets...
        </div>
      </div>
    );
  }

  if (datasets.length === 0) {
    return (
      <div style={{ marginBottom: '24px' }}>
        <div style={{ color: '#8899aa', padding: '20px', textAlign: 'center' }}>
          Nenhum dataset disponível
        </div>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '24px' }}>
      <h3 style={{ color: '#4fc3f7', marginBottom: '12px', fontSize: '18px' }}>
        📂 Selecione um Dataset
      </h3>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '12px'
      }}>
        {datasets.map((dataset: any) => (
          <div
            key={dataset.id}
            onClick={() => onSelect(dataset)}
            style={{
              background: selectedDataset?.id === dataset.id
                ? 'rgba(79, 195, 247, 0.15)'
                : 'rgba(15, 42, 74, 0.4)',
              borderRadius: '8px',
              padding: '12px 16px',
              border: selectedDataset?.id === dataset.id
                ? '1px solid #4fc3f7'
                : '1px solid transparent',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              if (selectedDataset?.id !== dataset.id) {
                e.currentTarget.style.borderColor = '#1a4a7a';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedDataset?.id !== dataset.id) {
                e.currentTarget.style.borderColor = 'transparent';
              }
            }}
          >
            <div style={{ fontWeight: 600, color: '#4fc3f7', fontSize: '15px' }}>
              {renderValue(dataset.dataset_name)}
            </div>
            <div style={{ fontSize: '13px', color: '#8899aa', marginTop: '4px' }}>
              📊 {renderValue(dataset.rows_count)} registros · 
              📋 {renderValue(dataset.columns_count)} colunas · 
              💾 {renderValue(dataset.memory_mb)} MB
            </div>
            <div style={{ fontSize: '12px', color: '#556677', marginTop: '4px' }}>
              v{renderValue(dataset.pipeline_version)} · {renderValue(dataset.created_at)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};